import Chart from 'chart.js/auto'
import { colors, lineChartOptions, formatDateLabel, reduceLabels } from './chart_config'

export function buildInvitationsChart(canvas, data) {
  const formattedLabels = reduceLabels(data.labels)

  return new Chart(canvas, {
    type: 'line',
    data: {
      labels: formattedLabels.length ? formattedLabels : data.labels.map(formatDateLabel),
      datasets: [
        {
          label: 'Sent',
          data: data.sent,
          borderColor: colors.purple[400],
          backgroundColor: 'transparent',
          borderDash: [5, 5]
        },
        {
          label: 'Accepted',
          data: data.accepted,
          borderColor: colors.purple[700],
          backgroundColor: colors.purpleAlpha[20],
          fill: true
        }
      ]
    },
    options: {
      ...lineChartOptions,
      plugins: {
        ...lineChartOptions.plugins,
        legend: {
          display: true,
          position: 'top',
          align: 'end',
          labels: {
            usePointStyle: true,
            padding: 16,
            color: 'rgb(51, 65, 85)', // gray-700
            font: { size: 12 }
          }
        },
        tooltip: {
          ...lineChartOptions.plugins.tooltip,
          callbacks: {
            title: (items) => {
              const idx = items[0].dataIndex
              return formatDateLabel(data.labels[idx])
            }
          }
        }
      }
    }
  })
}
